module.exports = __webpack_public_path__ + "static/media/81YHHLKNT7L._AC_SY550._SX._UX._SY._UY_.caaf495d.jpg";